import { render } from "./PlanEdit.vue?vue&type=template&id=2bb19467&scoped=true"
import script from "./PlanEdit.vue?vue&type=script&lang=js"
export * from "./PlanEdit.vue?vue&type=script&lang=js"

import "./PlanEdit.vue?vue&type=style&index=0&id=2bb19467&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb19467"]])

export default __exports__